module.exports = __webpack_public_path__ + "static/img/tech-data.ac56e21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/technology/tech-data.jpg
// module id = nyZj
// module chunks = 1